import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Order } from 'src/typings';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from 'src/app/services/notification.service';
import { getOrderPaymentDue } from '../order-status.util';

@Component({
  selector: 'app-liqpay-sum',
  templateUrl: './liqpay-sum.component.html',
  styleUrls: ['./liqpay-sum.component.scss']
})
export class LiqpaySumComponent {
  copyLinkLoading: boolean = false;

  sendLinkLoading: boolean = false;

  @Input() set order(payload: Order | undefined) {
    if (!payload) return;
    this._order = payload;
    this.sum.setValue(getOrderPaymentDue(payload as any));
  }

  private _order: Order | undefined;

  get order() {
    return this._order;
  }

  @Output() sendEvent: EventEmitter<void> = new EventEmitter();

  sum = new FormControl();

  constructor(
    private clipboard: Clipboard,
    private notificationService: NotificationService
  ) {}

  async send() {
    this.notificationService.warning('Отправка ссылки на оплату больше не поддерживается.');
  }

  async copyLinkToPay() {
    if (!this.order) return;
    this.clipboard.copy(String(this.sum.value || ''));
    this.notificationService.warning('Генерация ссылки на оплату больше не поддерживается.');
  }
}
